module.exports = __webpack_public_path__ + "static/media/Session.5d876f6f.png";